import { cloneDeep } from 'lodash';
export var updateListItem = (_ref, _selectedList, type) => {
  var item = _ref.item,
    index = _ref.index;
  var selectedList = cloneDeep(_selectedList);
  if (type === 'single') {
    if (!selectedList[index].isSelected) selectedList[index].isSelected = !selectedList[index].isSelected;
    selectedList.map((_item, _index) => {
      if (_index !== index) _item.isSelected = false;
      return item;
    });
  } else selectedList[index].isSelected = !selectedList[index].isSelected;
  return selectedList;
};